// src/components/relatorios/GraficoFunil.js
import React from 'react';

const STATUS_LABELS = {
  'orcamento_enviado': 'Orçamento Enviado',
  'aguardando_atendimento': 'Aguardando Atendimento',
  'em_andamento': 'Em Andamento',
  'finalizada': 'Finalizada',
  'faturar': 'Faturar',
  'faturado': 'Faturado'
};

const STATUS_COLORS = {
  'orcamento_enviado': '#f59e0b',
  'aguardando_atendimento': '#10b981',
  'em_andamento': '#3b82f6',
  'finalizada': '#8b5cf6',
  'faturar': '#f97316',
  'faturado': '#6366f1'
};

function GraficoFunil({ data }) {
  if (!data || data.length === 0) {
    return <div className="grafico-vazio">Nenhum dado disponível</div>;
  }

  const total = data.reduce((acc, item) => acc + parseInt(item.quantidade), 0);
  const maxQuantidade = Math.max(...data.map(item => parseInt(item.quantidade)));

  return (
    <div className="grafico-funil">
      {data.map((item, index) => {
        const quantidade = parseInt(item.quantidade);
        const largura = maxQuantidade > 0 ? (quantidade / maxQuantidade * 100) : 0;
        const percentual = total > 0 ? ((quantidade / total) * 100).toFixed(1) : 0;
        const cor = STATUS_COLORS[item.status] || '#6b7280';

        return (
          <div key={index} className="funil-item">
            <div className="funil-label">
              <span className="funil-status">{STATUS_LABELS[item.status] || item.status}</span>
              <span className="funil-quantidade">{quantidade} OS ({percentual}%)</span>
            </div>
            <div className="funil-barra-container">
              <div 
                className="funil-barra"
                style={{ 
                  width: `${largura}%`,
                  backgroundColor: cor
                }}
              />
            </div>
          </div>
        );
      })}

      <div className="funil-resumo">
        <span className="funil-resumo-label">Total de Oportunidades:</span>
        <span className="funil-resumo-valor">{total}</span>
      </div>
    </div>
  );
}

export default GraficoFunil;
